import { combineReducers } from 'redux';
import { authReducer } from './auth.reducer';
import { dyteReducer } from './dyte.reducer';

export const rootReducer = combineReducers({
    auth: authReducer,
    meeting: dyteReducer,
});
